import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import Modal from 'ds/components/modal';
import { H3 } from 'ds/components/typography';
import SuccessSignIcon from 'assets/svg/private-bulletin-promotion/modal-success-sign.svg';
import { RootAction, State } from 'store/state';
import { setRedeemPromotionPlanGrantResultModal } from 'store/state/app/actions';
import { isRedeemPromotionPlanGrantResultModalOpenSelector } from 'store/state/app/private-user-monetization/selectors';
import { Button } from 'ds/components/button';

const ContentRoot = styled.div(() => ({
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '420px',
}));

const Title = styled(H3)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 700,
  marginTop: theme.spacing(3),
  color: theme.colors.alert.green,
}));

const BtnWrapper = styled.div(({ theme }) => ({
  paddingTop: theme.spacing(3),
}));

interface RedeemPromotionPlanGrantResultModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RedeemPromotionPlanGrantResultModal: React.FC<RedeemPromotionPlanGrantResultModalProps> = props => {
  const { isOpen, onClose } = props;
  const { t } = useLocale();

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      mobileModalPositionBottom
    >
      <ContentRoot>
        <SuccessSignIcon width="60" height="60" />
        <Title>{t('redeemPromotionPlanGrantResultModal.successMessage')}</Title>
        <BtnWrapper>
          <Button size="large" fullWidth onClick={onClose}>
            {t('listingsPage.changeAgentModal.button.confirm')}
          </Button>
        </BtnWrapper>
      </ContentRoot>
    </Modal>
  );
};

const mapStateToProps = (state: State) => ({
  isOpen: isRedeemPromotionPlanGrantResultModalOpenSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onClose: () => dispatch(setRedeemPromotionPlanGrantResultModal({ isOpen: false })),
});

export default connect(mapStateToProps, mapDispatchToProps)(RedeemPromotionPlanGrantResultModal);
